import fetch from './communityFetch';

const postsTipOffList = params => fetch({ url: '/posts_tip_off_list', params });
const ignorePosts = ({ post_id }) => fetch({ url: `/ignore_posts/${post_id}`, methold: 'post' });
const tipOffDetail = params => fetch({ url: '/tip_off_detail', params });

const bannedPosts = ({ post_id }) => fetch({ url: `/banned_posts/${post_id}`, methold: 'post' });
const unblockPosts = ({ post_id }) => fetch({ url: `/unblock_posts/${post_id}`, methold: 'post' });

const bannedReply = ({ reply_id }) => fetch({ url: `/banned_reply/${reply_id}`, methold: 'post' });
const unblockReply = ({ reply_id }) => fetch({ url: `/unblock_reply/${reply_id}`, methold: 'post' });

const toppingPosts = ({ post_id }) => fetch({ url: `/topping_posts/${post_id}`, methold: 'post' });
const cancelToppingPosts = ({ post_id }) => fetch({ url: `/cancel_topping_posts/${post_id}`, methold: 'post' });

const essencePosts = ({ post_id }) => fetch({ url: `/essence_posts/${post_id}`, methold: 'post' });
const cancelEssencePosts = ({ post_id }) => fetch({ url: `/cancel_essence_posts/${post_id}`, methold: 'post' });

const replyTipOffList = params => fetch({ url: '/reply_tip_off_list', params });
const replyTipOff = ({ post_id }) => fetch({ url: `/banned_reply/${post_id}`, methold: 'post' });
const ignoreReply = ({ post_id }) => fetch({ url: `/ignore_reply/${post_id}`, methold: 'post' });
const replyTipOffDetail = params => fetch({ url: '/reply_tip_off_detail', params });

const postsList = params => {
  const temp = {};
  Object.keys(params).forEach(key => {
    if (params[key]) {
      temp[key] = params[key];
    }
  });
  return fetch({ url: '/posts_list', params: temp });
};
const postsQuery = params => fetch({ url: '/search_posts_list', params: { content: params.query, page_no: 1, page_size: 20 } });
const categorySearch = params => fetch({ url: '/category_search_list', params: { category_name: params.query } });
const addPosts = ({ params, methold }) => fetch({ url: '/posts', params, methold });
const updatePosts = ({ post_id, params, methold }) =>
  fetch({ url: `/edit_posts/${post_id}`, methold, params });

const controlPosts = ({ post_id, params, methold }) => fetch({ url: `/posts/${post_id}`, params, methold });
const replyList = ({ params }) => fetch({ url: '/reply_list', params });
const reply = ({ params }) => fetch({ url: '/reply', params, methold: 'post' });
const editReply = ({ reply_id, params }) => fetch({ url: `/edit_reply/${reply_id}`, params, methold: 'post' });
const delReply = ({ reply_id, params }) => fetch({ url: `/reply/${reply_id}`, params, methold: 'delete' });

export default {
  delReply,
  reply,
  replyList,
  categorySearch,
  addPosts,
  controlPosts,
  postsQuery,
  essencePosts,
  cancelEssencePosts,
  cancelToppingPosts,
  toppingPosts,
  unblockPosts,
  bannedPosts,
  bannedReply,
  unblockReply,
  postsList,
  postsTipOffList,
  ignorePosts,
  replyTipOffList,
  replyTipOff,
  ignoreReply,
  tipOffDetail,
  replyTipOffDetail,
  updatePosts,
  editReply
};
